// extracted by mini-css-extract-plugin
export default {"taskNotCompleteClickable":"styles__taskNotCompleteClickable___kgdcZ","taskCompleteClickable":"styles__taskCompleteClickable___HMIr7"};